import { ShieldCheck, MapPin, Tag, MessageCircle, Truck } from "lucide-react";

const items = [
  { icon: ShieldCheck, text: "Entregas seguras y responsables" },
  { icon: MapPin, text: "Seguimiento de tu envío" },
  { icon: Tag, text: "Precios competitivos" },
  { icon: MessageCircle, text: "Atención directa por WhatsApp" },
  { icon: Truck, text: "Experiencia en envíos a RD" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="bg-[#0B1F4D] text-white"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 lg:gap-4">
          {items.map(({ icon: Icon, text }, i) => (
            <div
              key={i}
              data-testid={`trust-item-${i}`}
              className="flex items-center gap-3 justify-center md:justify-start"
            >
              <Icon className="w-9 h-9 text-white flex-shrink-0" strokeWidth={1.75} />
              <p className="text-xs sm:text-sm font-bold uppercase tracking-wider text-white/95 leading-snug max-w-[180px]">
                {text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
